/**
 * Locale configuration. Structural, not editorial: the list mirrors
 * `SUPPORTED_LANGUAGES` in the Studio (`studio/constants/languages.ts`) and the
 * two must stay in sync — a locale missing here is unreachable, a locale
 * missing there has no content.
 */
export const LOCALES = ['de', 'en'] as const;

export type Locale = (typeof LOCALES)[number];

/** Base locale: the language existing content was authored in, and hreflang's x-default. */
export const DEFAULT_LOCALE: Locale = 'de';

/** BCP 47 tags for `inLanguage` in JSON-LD. `<html lang>` uses the short code. */
export const LOCALE_BCP47: Record<Locale, string> = {
    de: 'de-DE',
    en: 'en-US',
};

/** Request headers `proxy.ts` sets for server components that have no `params`. */
export const LOCALE_HEADER = 'x-locale';
export const PATHNAME_HEADER = 'x-pathname';
